import React from 'react';
import { Countdown, PriceCard } from './Shared';
export const FinalCtaSection = () => {
  return <section className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-74">
      <div className="max-w-7xl mx-auto text-center w-[92%] md:w-full" data-id="element-75">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6 leading-tight" data-id="element-76">
          ¿Cuánto cuesta seguir una semana más sin un sistema claro?
        </h2>
        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-77">
          Cada día que pasa sin estimulación, sin rutina y sin organización es
          un día que no vuelve. Vitalidad 360™ te da todo lo que necesitás para
          empezar hoy mismo.
        </p>
        <div className="mb-10 md:mb-20 flex justify-center" data-id="element-78">
          <PriceCard data-id="element-79" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-80">
          {['5 módulos + Módulo VIP + 3 bonos', '+240 páginas de contenido práctico', 'Acceso inmediato', 'Garantía 30 días'].map((item, i) => <div key={i} className="bg-familia-card border border-familia-cyan/15 p-4 rounded-xl flex items-center justify-center gap-3" data-id="element-81">
              <span className="text-familia-green" data-id="element-82">✅</span>
              <span className="text-xs font-bold uppercase tracking-wider" data-id="element-83">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};